<section class="vd-recs" [attr.aria-label]="title">
    <div class="vd-recs-head">
        <h2 class="vd-recs-title">{{ title }}</h2>
        <div class="vd-recs-arrows">
            <button type="button" class="vd-icon-btn" (click)="scroll(-1)" aria-label="Scroll back"><app-vd-icon name="back"></app-vd-icon></button>
            <button type="button" class="vd-icon-btn vd-recs-next" (click)="scroll(1)" aria-label="Scroll forward"><app-vd-icon name="back"></app-vd-icon></button>
        </div>
    </div>
    <div class="vd-recs-strip" #strip>
        <button type="button" class="vd-rec" *ngFor="let card of cards; trackBy: trackByCard" (click)="open.emit(card)" [title]="card.title">
            <span class="vd-rec-img"><img *ngIf="card.image" [src]="card.image" alt="" loading="lazy" decoding="async"></span>
            <span class="vd-rec-title">{{ card.title }}</span>
        </button>
    </div>
</section>
